import { css, CSSProperties } from 'styled-components'

export type TGapMixin = Pick<CSSProperties, 'gap' | 'columnGap' | 'rowGap'>

export const Gap = ({ gap, columnGap, rowGap }: TGapMixin) => css`
  gap: ${gap};
  column-gap: ${columnGap};
  row-gap: ${rowGap};
`
